import { render, staticRenderFns } from "./AppPageFootBar.vue?vue&type=template&id=4fe3396a&scoped=true&"
import script from "./AppPageFootBar.vue?vue&type=script&lang=js&"
export * from "./AppPageFootBar.vue?vue&type=script&lang=js&"
import style0 from "./AppPageFootBar.vue?vue&type=style&index=0&id=4fe3396a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fe3396a",
  null
  
)

export default component.exports